import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const WHATSAPP_NUMBER = '919573757096';
const EMAIL = 'nithinsai2603@gmail.com';

function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setHidden(window.scrollY < 320);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-[55] flex flex-col items-end gap-3 md:bottom-7 md:right-7">
      <AnimatePresence>
        {!hidden && open && (
          <motion.div
            key="actions"
            initial={{ opacity: 0, y: 12, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.92 }}
            transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-end gap-2"
          >
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20Nithin%2C%20I%20found%20your%20portfolio%20and%20want%20to%20discuss%20a%20project.`}
              target="_blank"
              rel="noreferrer"
              className="float-pill ui-button-light inline-flex items-center gap-3 rounded-full border border-ink/15 bg-snow px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink"
              aria-label="Chat on WhatsApp"
            >
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#25D366] text-white">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
                  <path d="M20.52 3.48A11.86 11.86 0 0 0 12.05.04C5.5.04.2 5.35.2 11.89c0 2.1.55 4.13 1.6 5.93L0 24l6.36-1.67a11.84 11.84 0 0 0 5.69 1.45h.01c6.55 0 11.85-5.32 11.85-11.85 0-3.17-1.23-6.15-3.39-8.45zM12.06 21.6h-.01a9.7 9.7 0 0 1-4.96-1.36l-.36-.21-3.77.99 1.01-3.68-.24-.38a9.74 9.74 0 0 1-1.5-5.17c0-5.39 4.39-9.78 9.84-9.78 2.63 0 5.1 1.02 6.95 2.87a9.74 9.74 0 0 1 2.88 6.93c0 5.39-4.39 9.78-9.84 9.78zm5.4-7.32c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.2.3-.76.96-.93 1.15-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.88-.78-1.48-1.74-1.65-2.04-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.18-.24-.58-.49-.5-.66-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.47 0 1.45 1.06 2.86 1.21 3.06.15.2 2.09 3.19 5.07 4.47.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.75-.71 2-1.4.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.34z"/>
                </svg>
              </span>
              WhatsApp
            </a>

            <a
              href={`mailto:${EMAIL}`}
              className="float-pill ui-button-light inline-flex items-center gap-3 rounded-full border border-ink/15 bg-snow px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink"
              aria-label="Send email"
            >
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-coal text-white">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 7l9 6 9-6M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/>
                </svg>
              </span>
              Email
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {!hidden && (
          <motion.button
            key="trigger"
            type="button"
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.6 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-label={open ? 'Close contact options' : 'Open contact options'}
            className="float-pill relative inline-flex h-14 w-14 items-center justify-center rounded-full border border-ink/20 bg-coal text-white"
          >
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent/40" aria-hidden="true" />
            <span className="relative">
              {open ? (
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
                  <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
                  <path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-4l-5 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                </svg>
              )}
            </span>
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}

export default FloatingContact;
